import { render, staticRenderFns } from "./HomeRedirectDetail.vue?vue&type=template&id=4de5272c&scoped=true"
import script from "./HomeRedirectDetail.vue?vue&type=script&lang=js"
export * from "./HomeRedirectDetail.vue?vue&type=script&lang=js"
import style0 from "./HomeRedirectDetail.vue?vue&type=style&index=0&id=4de5272c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de5272c",
  null
  
)

export default component.exports